<template>
  <div class="equipe-selector-wrap">
    <div class="equipe-selector" role="radiogroup" aria-label="Equipe">
      <button
        v-for="equipe in equipes"
        :key="equipe.value"
        type="button"
        class="equipe-btn"
        :class="{ selected: modelValue === equipe.value }"
        :style="{ background: equipe.hex, color: equipe.textColor }"
        :aria-checked="modelValue === equipe.value"
        role="radio"
        @click="$emit('update:modelValue', equipe.value)"
      >
        <span class="equipe-btn-label">{{ equipe.label }}</span>
        <svg v-if="modelValue === equipe.value" class="equipe-check" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
          <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41L9 16.17z"/>
        </svg>
      </button>
    </div>

    <button
      type="button"
      class="equipe-btn-clear"
      :class="{ selected: modelValue === null }"
      :aria-checked="modelValue === null"
      role="radio"
      @click="$emit('update:modelValue', null)"
    >
      <span>Sem equipe</span>
      <svg v-if="modelValue === null" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
        <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41L9 16.17z"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { EQUIPES } from '../lib/equipes'

export default {
  name: 'EquipeSelector',
  props: {
    // String com value da equipe ou null pra "Sem equipe"
    modelValue: { type: String, default: null }
  },
  emits: ['update:modelValue'],
  data() { return { equipes: EQUIPES } }
}
</script>

<style scoped>
.equipe-selector-wrap {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}
.equipe-selector {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-sm);
}
.equipe-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 72px;
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  border: 2px solid transparent;
  cursor: pointer;
  font-family: var(--font-primary);
  font-size: var(--text-sm);
  font-weight: 700;
  letter-spacing: 0.4px;
  transition: var(--transition-fast);
  box-shadow: var(--shadow-button);
}
.equipe-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-button-hover);
}
.equipe-btn.selected {
  border-color: var(--color-text-primary);
  transform: scale(1.04);
  box-shadow: var(--shadow-hover);
}
.equipe-btn-label {
  text-transform: uppercase;
}
.equipe-check {
  position: absolute;
  top: 6px;
  right: 6px;
}

.equipe-btn-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  align-self: center;
  padding: 8px 16px;
  background: transparent;
  color: var(--color-text-muted);
  border: 1px dashed #bbb;
  border-radius: 16px;
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
}
.equipe-btn-clear:hover {
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}
.equipe-btn-clear.selected {
  background: var(--color-text-primary);
  color: #fff;
  border-color: var(--color-text-primary);
  border-style: solid;
}

@media (max-width: 420px) {
  .equipe-selector { grid-template-columns: repeat(2, 1fr); }
}
</style>
